import { useState, useEffect } from "react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState(null);
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {});
    api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  if (!customers) return <div className="h-40 bg-muted animate-pulse" />;

  return (
    <div data-testid="admin-customers">
      <h1 className="font-serif text-3xl font-semibold mb-8">Customers <span className="text-sm text-muted-foreground font-sans font-normal">({customers.length})</span></h1>
      {customers.length === 0 ? (
        <p className="text-sm text-muted-foreground bg-white border border-black/10 p-12 text-center" data-testid="no-customers">No registered customers yet.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {customers.map((c) => {
            const cOrders = orders.filter((o) => o.user_id === c.id || o.customer.email === c.email);
            return (
              <div key={c.id} className="bg-white border border-black/10" data-testid={`customer-${c.email}`}>
                <button onClick={() => setExpanded(expanded === c.id ? null : c.id)} className="w-full flex flex-wrap items-center gap-3 p-4 text-sm text-left" data-testid={`customer-toggle-${c.email}`}>
                  <p className="font-medium flex-1 min-w-[120px]">{c.name}</p>
                  <p className="text-muted-foreground">{c.email}</p>
                  <p className="text-muted-foreground">{c.phone || "—"}</p>
                  <p className="text-xs uppercase tracking-widest text-gold">{c.order_count} orders</p>
                  <p className="text-xs text-muted-foreground">Since {new Date(c.created_at).toLocaleDateString("en-IN")}</p>
                </button>
                {expanded === c.id && (
                  <div className="border-t border-black/10 p-4" data-testid={`customer-orders-${c.email}`}>
                    <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Order History</p>
                    {cOrders.length === 0 ? (
                      <p className="text-sm text-muted-foreground">No orders yet.</p>
                    ) : (
                      cOrders.map((o) => (
                        <div key={o.id} className="flex flex-wrap gap-3 text-sm py-1.5 border-b border-black/5 last:border-0">
                          <span className="font-medium">{o.order_number}</span>
                          <span className="text-muted-foreground">{new Date(o.created_at).toLocaleDateString("en-IN")}</span>
                          <span>₹{o.total.toLocaleString("en-IN")}</span>
                          <span className="text-xs uppercase tracking-widest text-gold">{o.status}</span>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
